import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const Container = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  overflow: hidden;

  .top {
    min-height: 75px;
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    margin-top: ${({ theme: { token } }) => token.margin}px;
    justify-content: center;
    gap: ${({ theme: { token } }) => token.marginLG}px;
    flex-wrap: wrap;

    .eco-select-station {
      padding: 0;
      width: 310px;
      margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
    }

    .proactive-engine-box {
      visibility: hidden;
      height: 0;
    }
  }

  .bottom {
    display: flex;
    flex-grow: 1;
    height: 100%;

    .tabs {
      display: flex;
      overflow: hidden;
      margin: 0 0 10px 0;
      width: 100%;
    }
  }

  .tab-assets-control-center {
    height: 100%;
  }

  .tab-assets-control-center::-webkit-scrollbar {
    display: none;
  }

  .ant-tabs {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 0;
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
    box-sizing: border-box;

    .ant-tabs-content-holder {
      display: flex;
      flex-direction: column;
      overflow: auto;

      .ant-tabs-content {
        flex-grow: 1;
        flex-shrink: 0;
      }
    }

    .ant-tabs-nav {
      .ant-tabs-nav-wrap {
        display: flex;

        .ant-tabs-tab {
          padding-left: ${({ theme: { token } }) => token.paddingXS}px;
          padding-right: ${({ theme: { token } }) => token.paddingXS}px;
          margin-left: ${({ theme: { token } }) => token.margin}px;
          margin-right: ${({ theme: { token } }) => token.margin}px;
          flex-grow: 0;
        }

        .ant-tabs-ink-bar {
          background-color: ${({ theme: { token } }) => token.colorPrimary};
          height: 3px;
          border-radius: 5px 5px 0 0;
        }
      }
    }
  }
`;

